<template>
  <div id="terms-conditions" class="fill-height align-start">
    <v-row class="g-container" no-gutters>
      <v-col>
        <div class="p-content-text mx-auto mt-2">
          <h2 class="ma-0">{{ $route.meta.title }}</h2>
          <br />
          <i-terms-conditions-text />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iTermsConditionsText from '@/modules/auth/components/TermsConditionsText.vue'

export default {
  components: {
    iTermsConditionsText
  },

  computed: {
    ...mapGetters('tenant', ['termsConditionsEnabled'])
  },

  created() {
    if (!this.termsConditionsEnabled) {
      this.$router.replace({ name: 'dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped>
#terms-conditions {
  .p-content-text {
    max-width: 940px;
  }
}
</style>
